import List from '@/shared/dtos/List'
import { HttpService } from '@/shared/services'
import { Module } from '../../modules/payrolls-config/models/Module'
import { GetModuleInput } from '../../modules/payrolls-config/services/interfaces'

const http = new HttpService()

export const getModules = async (dto: GetModuleInput) => {
  let url = 'module'
  if (dto.onlyAdminModules) {
    url += '?onlyAdminModules=true'
  }

  const response = await http.get<List<Module[]>>(url)
  return response.data
}
